<template>
  <app-list
      title="Mining App Types"
      :items-per-page="500"
      no-search-padding
      :search-by="[
        'Name',
      ]"
      show-filters
      export-query-type="workerMiningAppTypesExport"
      :query-fields="[
        'ID',
        'Name',
        'CurrentVersion',
        'CreatedAt',
        'UpdatedAt',
      ]"
      delete-mutation-type="deleteWorkerMiningAppType"
      delete-mutation-field="ids"
      delete-by="ID"
      add-link="worker_mining_app_types/add"
      query-type="workerMiningAppTypes"
      :row-click="onRowClick"
  >
    <template #head>
      <lth sort-by="Name" width="120">Name</lth>
      <lth sort-by="CurrentVersion" width="120">Current Version</lth>
      <lth sort-by="CreatedAt">Created At</lth>
      <lth sort-by="UpdatedAt" width="150">Updated At</lth>
    </template>
    <template #row="{item}">
      <ltd :link="`worker_mining_app_types/edit/${item.ID}`">{{ item.Name }}</ltd>
      <ltd>{{ item.CurrentVersion }}</ltd>
      <ltd date>{{ item.CreatedAt }}</ltd>
      <ltd date>{{ item.UpdatedAt }}</ltd>
    </template>
  </app-list>
</template>
<script>
export default {

  methods: {
    onRowClick: function (item) {
      this.goToPage(`worker_mining_app_types/edit/${item.ID}`);
    },
  },

  data: () => ({}),

  mounted() {

  }
}
</script>